var map = {
	"./404.svg": 949,
	"./Categories.png": 950,
	"./Edit-menu.svg": 951,
	"./Egg.svg": 952,
	"./Emaier-Header.png": 953,
	"./Qr-4.png": 954,
	"./_duplicate.svg": 955,
	"./_overview.svg": 956,
	"./add-white.svg": 957,
	"./alert.svg": 958,
	"./all_category.svg": 959,
	"./archive.svg": 960,
	"./armchair.svg": 961,
	"./arrow-circle-right.svg": 962,
	"./arrow-left-circle.svg": 963,
	"./arrow-right-circle.svg": 964,
	"./arrow-right.svg": 965,
	"./asc-up-white.svg": 966,
	"./asc.png": 967,
	"./asc.svg": 968,
	"./back-arrow.svg": 969,
	"./barcode-icon.svg": 970,
	"./beverages.svg": 971,
	"./blue-edit-pen.svg": 972,
	"./blue-eye.svg": 973,
	"./box-office.svg": 974,
	"./broken-seat.jpg": 975,
	"./calendar_list.svg": 976,
	"./calender.svg": 362,
	"./chevron-down.svg": 977,
	"./chevron-left.svg": 978,
	"./cinema-mamagement-sidebar.svg": 979,
	"./claendar.svg": 311,
	"./clock-1.svg": 980,
	"./clock.svg": 981,
	"./close-button.svg": 714,
	"./close-white.svg": 716,
	"./close-x.svg": 306,
	"./collapse-up.svg": 982,
	"./collapse.svg": 983,
	"./connection-lost.svg": 360,
	"./consumable-raw-material.svg": 984,
	"./copy.svg": 985,
	"./copy_image_icon.png": 986,
	"./delete-red-light.svg": 987,
	"./delete-red.svg": 723,
	"./delete.svg": 697,
	"./deliver-icon.svg": 988,
	"./desc-down-white.svg": 989,
	"./desc.svg": 990,
	"./distributors-sidebar.svg": 991,
	"./download.svg": 992,
	"./dragndrop.svg": 993,
	"./dragndrop2.svg": 994,
	"./duplicate.svg": 995,
	"./duplicateScreen.svg": 996,
	"./e-wallet-icon-black.svg": 997,
	"./edit-pen-blue.svg": 998,
	"./edit-pen-white.svg": 999,
	"./edit-pen.svg": 1000,
	"./edit.svg": 1001,
	"./email.png": 1002,
	"./empty-image.svg": 1003,
	"./excel.svg": 1004,
	"./external-link.svg": 1005,
	"./eye.svg": 1006,
	"./filter-icon.svg": 1007,
	"./flag.svg": 1008,
	"./fnb-app-order.svg": 1009,
	"./fnb-beverages.svg": 1010,
	"./fnb-brownie.svg": 1011,
	"./fnb-combo.svg": 1012,
	"./fnb-desert.svg": 1013,
	"./fnb-eatables.svg": 1014,
	"./fnb-make-your-combo.svg": 1015,
	"./fnb-popcorn.svg": 1016,
	"./fnbtransactionIcon.svg": 1017,
	"./fullscreen-icon.svg": 724,
	"./funnel.svg": 1018,
	"./globe.svg": 1019,
	"./green-tick.svg": 1020,
	"./grid-view.svg": 1021,
	"./hide-password.svg": 363,
	"./home-icon.svg": 1022,
	"./home.svg": 1023,
	"./icon-black-play.svg": 1024,
	"./icon-dot.svg": 1025,
	"./icon-fnb.svg": 1026,
	"./icon-marketing.svg": 1027,
	"./icon-no-seat.png": 1028,
	"./icon-no-seat.svg": 1029,
	"./icon-option.svg": 1030,
	"./icon-poin-of-sale.svg": 1031,
	"./icon-recliner.svg": 1032,
	"./icon-report.svg": 1033,
	"./icon-sofa-dark-1.svg": 1034,
	"./icon-sofa-dark.png": 1035,
	"./icon-sofa-dark.svg": 1036,
	"./icon-sofa.svg": 1037,
	"./importfile.svg": 1038,
	"./info.svg": 717,
	"./info2.svg": 1039,
	"./keyboard-icon.svg": 1040,
	"./kitchen_display.svg": 1041,
	"./language-icon.svg": 364,
	"./left-caret.svg": 1042,
	"./link.svg": 1043,
	"./list-view.svg": 1044,
	"./loading.svg": 365,
	"./lock.svg": 1045,
	"./login-password.png": 366,
	"./login-user.png": 367,
	"./logout.svg": 718,
	"./masters-sidebar.svg": 1046,
	"./merchandise.svg": 1047,
	"./minus.svg": 1048,
	"./movie-pass-svg.svg": 706,
	"./movie-rolling.svg": 1049,
	"./mulitSchedule.svg": 1050,
	"./multicurrency.svg": 1051,
	"./multifnb.svg": 1052,
	"./nav-plus.svg": 1053,
	"./new_filter_icon.svg": 1054,
	"./no-image.svg": 1055,
	"./no-schedule.svg": 142,
	"./non-veg-mark.png": 1056,
	"./non-veg-mark.svg": 1057,
	"./notification.svg": 1058,
	"./open-link-blue.svg": 1059,
	"./openPlanned.svg": 1060,
	"./overview.svg": 1061,
	"./overview2.svg": 1062,
	"./pdf-icon.svg": 1063,
	"./pdf.svg": 1064,
	"./pickup-ticket-icon.svg": 1065,
	"./pickupfnb.svg": 1066,
	"./play.svg": 1067,
	"./plus.svg": 1068,
	"./pointofsale-1.svg": 1069,
	"./pointofsale-2.svg": 1070,
	"./pointofsale.png": 1071,
	"./portfolio.svg": 1072,
	"./pos-fnb-no-itmes.svg": 710,
	"./pos-refresh.svg": 1073,
	"./primary/chevron-down.svg": 1074,
	"./primary/download.svg": 1075,
	"./primary/edit.svg": 1076,
	"./primary/filter.svg": 1077,
	"./primary/printer.svg": 1078,
	"./print-icon.svg": 1079,
	"./print.svg": 1080,
	"./question.svg": 1081,
	"./question1.svg": 1082,
	"./question2.svg": 725,
	"./question3.svg": 1083,
	"./recliner-1.svg": 1084,
	"./recliner.png": 1085,
	"./refund-icon.svg": 1086,
	"./reload-icon-pos.svg": 1087,
	"./reload-icon.svg": 1088,
	"./restore.svg": 1089,
	"./right-caret.svg": 1090,
	"./role-management-sidebar.svg": 1091,
	"./save.svg": 1092,
	"./schedule-icon.svg": 1093,
	"./school-calendar.svg": 1094,
	"./search-global-white.svg": 1095,
	"./search-global.svg": 1096,
	"./search.svg": 1097,
	"./searchIcon.svg": 1098,
	"./seat-icon-2.svg": 1099,
	"./seat-icon.svg": 1100,
	"./seat-icons/3-wheelChair.png": 1101,
	"./seat-icons/block_seat_new.png": 1102,
	"./seat-icons/broken-seat-1.svg": 1103,
	"./seat-icons/broken-seat-2.svg": 1104,
	"./select-food.png": 726,
	"./settings.svg": 1105,
	"./show-password.svg": 368,
	"./slider-triangle.svg": 719,
	"./snack.svg": 720,
	"./sort.svg": 1106,
	"./star-empty.svg": 1107,
	"./star-fill.svg": 1108,
	"./success-tick.svg": 1109,
	"./suitcase.svg": 1110,
	"./swap.svg": 1111,
	"./tick-green-item.svg": 727,
	"./tick-green.svg": 1112,
	"./ticket-icon.svg": 1113,
	"./trash.svg": 1114,
	"./unpaid-reservation.svg": 702,
	"./updown-white.svg": 1115,
	"./updown.svg": 1116,
	"./user-attribute.svg": 1117,
	"./user-attributes.svg": 1118,
	"./user-female.svg": 1119,
	"./user-male-white.svg": 1120,
	"./user-male.svg": 1121,
	"./user-profile.svg": 1122,
	"./userProfile.png": 1123,
	"./veg-food-mark-white.png": 1124,
	"./veg-foog-mark-trans.png": 1125,
	"./view.png": 1126,
	"./view.svg": 1127
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 948;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 948
// module chunks = 37